import React__default, { useEffect } from 'react';
import useCountDown from 'react-countdown-hook';
import { useFormContext, get } from 'react-hook-form';
import { Alert } from '@sravni/react-design-system';
import { TOO_MANY_REQUESTS_ERROR_TYPE, DEFAULT_ERROR_MESSAGE_COUNT_DOWN_START_TIME } from '../../constansts/index.js';
import { convertMillisecondsToHumanString } from '../../helpers/time.js';
import { splitRetryAfterAndErrorType } from '../../helpers/utils.js';

const INPUT_NAME = "root.server" /* FIELD_NAME.SERVER */;
const ServerErrorMessage = React__default.forwardRef((props, ref) => {
    const { clearErrors, formState: { errors }, } = useFormContext();
    const error = get(errors, INPUT_NAME);
    const isErrorExist = typeof error?.message === 'string';
    const [countDown, { start: startCountDownTimer, reset: resetCountDownTimer }] = useCountDown(0, 1000);
    useEffect(() => {
        if (!isErrorExist)
            return;
        if (!(typeof error.type === 'string') || !error.type.includes(TOO_MANY_REQUESTS_ERROR_TYPE))
            return;
        const [_, timerMilliSeconds] = splitRetryAfterAndErrorType(error.type);
        startCountDownTimer(timerMilliSeconds || DEFAULT_ERROR_MESSAGE_COUNT_DOWN_START_TIME);
    }, [error, isErrorExist, startCountDownTimer]);
    useEffect(() => {
        if (countDown === 0) {
            resetCountDownTimer();
            clearErrors(INPUT_NAME);
        }
    }, [countDown, resetCountDownTimer, clearErrors]);
    if (!error)
        return null;
    return (React__default.createElement(Alert, { color: "red", ...props, ref: ref },
        error.message,
        typeof error.type === 'string' && error.type.includes(TOO_MANY_REQUESTS_ERROR_TYPE)
            ? ` ${convertMillisecondsToHumanString(countDown)}`
            : ''));
});

export { ServerErrorMessage };
//# sourceMappingURL=view.js.map
